import { Button } from "./button"
import { StatusPill } from "./status_pill"

export function NotificationItem({
  title,
  body,
  categoryLabel,
  eventLabel,
  eventTone = "info",
  timestampLabel,
  isRead,
  targetLabel,
  compact = false,
  onOpen,
  onMarkRead,
}: {
  title: string
  body: string
  categoryLabel?: string
  eventLabel: string
  eventTone?: "neutral" | "success" | "warning" | "danger" | "info"
  timestampLabel: string
  isRead: boolean
  targetLabel?: string
  compact?: boolean
  onOpen?: () => void
  onMarkRead?: () => void
}) {
  const canOpen = Boolean(onOpen)
  const canMarkRead = Boolean(onMarkRead) && !isRead

  return (
    <article
      className={`rounded-2xl border transition-colors ${
        isRead
          ? "border-slate-200 bg-white"
          : "border-blue-200 bg-gradient-to-br from-blue-50/90 to-white shadow-sm"
      } ${compact ? "p-3" : "p-4"}`}
    >
      <div className="flex items-start gap-3">
        <div className="mt-1 shrink-0">
          <span
            className={`block rounded-full ${compact ? "h-2.5 w-2.5" : "h-3 w-3"} ${
              isRead ? "bg-slate-200" : "bg-blue-500 ring-4 ring-blue-100"
            }`}
          />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
            <div className="min-w-0">
              {categoryLabel ? (
                <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-400">
                  {categoryLabel}
                </p>
              ) : null}
              <div className="flex flex-wrap items-center gap-2">
                <StatusPill tone={isRead ? "neutral" : eventTone}>{eventLabel}</StatusPill>
                {!isRead ? <span className="text-[11px] font-semibold uppercase tracking-wide text-blue-600">Unread</span> : null}
              </div>
              <h3 className={`mt-2 font-semibold text-slate-900 ${compact ? "text-sm" : "text-sm sm:text-base"}`}>
                {title}
              </h3>
            </div>
            <p className="shrink-0 text-[11px] font-medium text-slate-400">{timestampLabel}</p>
          </div>
          <p className={`mt-2 text-slate-600 ${compact ? "text-xs leading-5" : "text-sm leading-6"}`}>
            {body}
          </p>
          {(canOpen || canMarkRead || targetLabel) ? (
            <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center">
              {targetLabel ? (
                <span className="text-[11px] font-medium uppercase tracking-wide text-slate-400">
                  {targetLabel}
                </span>
              ) : null}
              <div className="flex flex-wrap gap-2">
                {canOpen ? (
                  <Button size="sm" variant="secondary" type="button" onClick={onOpen}>
                    Open
                  </Button>
                ) : null}
                {canMarkRead ? (
                  <Button size="sm" variant="ghost" type="button" onClick={onMarkRead}>
                    Mark read
                  </Button>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </article>
  )
}
